export function getEventImages(event: any): string[] {
  const images: string[] = [];
  if (!event) return images;

  // 1. coverImage (primary event image)
  if (event.coverImage && typeof event.coverImage === 'string' && event.coverImage.trim()) {
    images.push(event.coverImage);
  }

  // 2. media.images[] (additional images)
  if (event.media?.images && Array.isArray(event.media.images)) {
    event.media.images.forEach((url: any) => {
      if (typeof url === 'string' && url.trim()) images.push(url);
    });
  }

  // Remove duplicates
  return Array.from(new Set(images));
} 